import { render, staticRenderFns } from "./InsuranceFilesDialog.vue?vue&type=template&id=5564974a&"
import script from "./InsuranceFilesDialog.vue?vue&type=script&lang=js&"
export * from "./InsuranceFilesDialog.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceFilesDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VDatePicker,VDialog,VIcon,VTabItem,VTabsItems})
